import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    padding-bottom: 40px;
    row-gap: 32px;
    background-color: #F9F9F9;
    height: max-content;
`;

export const Header = styled.div`
    padding: 20px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F2F2F2;

    ${MediaQuery.medium(css`
        padding: 20px 32px;
    `)};
`;

export const Title = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 20px;
    `)};
`;

export const SelectedCounter = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 16px;
    `)};
`;

export const Body = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    padding: 0 20px;

    ${MediaQuery.medium(css`
        padding: 0 32px;
    `)};
`;

export const Accordion = styled.div`
    display: grid;
    grid-template-columns: auto 48px;
    column-gap: 15px;
`;

export const ExpandCTA = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

export const ExpandButton = styled.button`
    grid-column: 2;
    justify-self: end;
    display: flex;
    padding: 0;
    height: max-content;
    border: none;
    outline: none;
    background: none;
    padding: 6px 0;
    cursor: pointer;
    transform: rotate(${({ isExpanded }) => (isExpanded ? '180deg' : '0deg')});
    transition: transform .2s ease-in;

    &:focus {
        outline: none;
    }

    svg {
        width: 10px;
        height: 10px;
    }

    ${MediaQuery.medium(css`
        svg {
            height: 14px;
            width: 14px;
        }
    `)};
`;

export const PriceIcon = styled.p`
    grid-column: 1;
    margin: 0;
    justify-self: start;
    height: max-content;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #63666A;
`;

export const DetailsContainer = styled.div`
    grid-column: 1 / -1;
    padding: 16px 32px;
    display: ${({ isExpanded }) => (isExpanded ? 'grid' : 'none')};
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 20px;
    grid-row: 2;

    ${MediaQuery.medium(css`
        grid-template-columns: 128px 128px auto;
        column-gap: 20px;
        grid-auto-flow: unset;
    `)};
`;

export const Description = styled.p`
    grid-column: 1 / -1;
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #63666A;

    ${MediaQuery.medium(css`
        font-size: 16px;
    `)};
`;

export const Tester = styled.div`
    display: grid;
    grid-template-columns: 20px auto;
`;
